/**
 * Balíček a odhadzovací balíček po stranách ruky.
 *
 * Poloha nie je kozmetika: zahraná karta odletí doprava na odhod, takže hráč
 * vidí, kam zmizla, a vie si ju tam dohľadať — odhod je v Unmatched verejný.
 * Vľavo je balíček, z ktorého sa ťahá; keď sa vyprázdni, **nemieša sa**, ale
 * každá tvoja figúrka dostane 2 zranenia za každú nedotiahnutú kartu, preto
 * je nízky stav vidieť ako výstrahu.
 */

import type { CardDef } from '@unmatched/engine';

import { Card } from './Card.js';

interface DrawProps {
  count: number;
}

export function DrawPile({ count }: DrawProps) {
  const className = ['pile', 'pile--draw', count === 0 ? 'is-empty' : count <= 3 ? 'is-low' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={className}>
      <div className="pile__slot">
        {count === 0 ? (
          <div className="pile__ghost">prázdny</div>
        ) : (
          <>
            {/* Vrstvy pod vrchnou kartou dávajú kôpke hrúbku. */}
            {count > 2 ? <div className="pile__layer pile__layer--2" /> : null}
            {count > 1 ? <div className="pile__layer pile__layer--1" /> : null}
            <div className="card card--back pile__top" />
          </>
        )}
        <span className="pile__count">{count}</span>
      </div>
      <span className="pile__label">
        Balíček
        {count === 0 ? <b className="pile__warn">ťah = 2 zranenia</b> : null}
      </span>
    </div>
  );
}

interface DiscardProps {
  count: number;
  /** Vrchná karta odhodu — posledná odhodená. */
  top: CardDef | null;
  onOpen: () => void;
  onHover?: (def: CardDef | null, rect?: DOMRect) => void;
}

export function DiscardPile({ count, top, onOpen, onHover }: DiscardProps) {
  return (
    <div className={`pile pile--discard${count === 0 ? ' is-empty' : ''}`}>
      <div className="pile__slot">
        {count > 2 ? <div className="pile__layer pile__layer--2" /> : null}
        {count > 1 ? <div className="pile__layer pile__layer--1" /> : null}
        {top ? (
          <Card def={top} onClick={onOpen} onHover={onHover} />
        ) : (
          <div className="pile__ghost">prázdny</div>
        )}
        {count > 0 ? <span className="pile__count">{count}</span> : null}
      </div>
      <span className="pile__label">
        Odhod
        {count > 0 ? (
          <button type="button" className="pile__browse" onClick={onOpen}>
            prezrieť
          </button>
        ) : null}
      </span>
    </div>
  );
}
